<template lang="html">
    <div class="about">
        <HomeHeaderIndex></HomeHeaderIndex>
        <div class="bg">
            <div>
                <p class="p1">关于我们</p>
                <p class="p2">About Us</p>
            </div>
            <img :src="$store.state.static_img_url + 'pic/index/aboutbg.png'">
        </div>
        <div class="center">
            <div class="content">
                <div class="item intro">
                    <div class="title title-l">
                        <img :src="$store.state.static_img_url + 'pic/index/tl.png'">
                        <span>平台介绍</span>
                    </div>
                    <div class="desc">动脉橙产业智库，以独创的在线数据库方式为数字健康产业人士提供全方位和实时的市场资讯、行业数据和分析师见解，帮助您更加全面了解产业发展动态与趋势，做出更好的决策判断，获取竞争优势。</div>
                    <img class="introl" :src="$store.state.static_img_url + 'pic/index/introl.png'">
                    <img class="intror" :src="$store.state.static_img_url + 'pic/index/intror.png'">
                </div>
                <div class="item">
                    <div class="title title-r">
                        <img :src="$store.state.static_img_url + 'pic/index/tr.png'">
                        <span>核心团队</span>
                    </div>
                    <div class="desc">核心团队在数字健康领域的资深经验是公司竞争优势的保障。团队具备丰富的实践经验，对企业经营运作有着深刻理解和感悟，对机遇和风险有较强的审慎判断力，管理团队具备较强的管理和执行能力。</div>
                </div>
                <div class="item">
                    <div class="title title-l">
                        <img :src="$store.state.static_img_url + 'pic/index/tl.png'">
                        <span>合作案例</span>
                    </div>
                    <div class="cooperation-list">
                        <div v-for="item,index in entity_list" :key="index"><img :src="$store.state.static_img_url+item.path" /></div>
                    </div>
                </div>
                <div class="item">
                    <div class="title title-r">
                        <img :src="$store.state.static_img_url + 'pic/index/tr.png'">
                        <span>联系我们</span>
                    </div>
                    <div class="list">
                        <div
                        v-for="item,index in contact_list"
                        :key="index"
                        >
                        <div>
                            <div class="p1">{{item.title}}</div>
                            <div class="line"></div>
                            <div class="p2">{{item.name}}</div>
                            <div class="p2">{{item.mobile}}</div>
                        </div>
                        <img :src="$store.state.static_img_url + item.ewm" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <HomeFooterIndex></HomeFooterIndex>
    </div>
</template>
<script>
import HomeHeaderIndex from '@/components/HomeHeaderIndex.vue'
import HomeFooterIndex from '@/components/HomeFooterIndex.vue'
export default {
  components: { HomeHeaderIndex, HomeFooterIndex },
  data() {
      return {
            contact_list: [
                { title: '体验反馈', name: '孙老师', mobile: '18523202324（微信同号）', ewm: 'pic/contact/syc.png' },
                { title: '内容服务', name: '唐老师', mobile: '13102347860（微信同号）', ewm: 'pic/contact/nrxq.png' },
                { title: '数据服务', name: '唐老师', mobile: '13102347860（微信同号）', ewm: 'pic/contact/nrxq.png' },
                { title: '商务需求', name: '动脉橙', mobile: '17338335471（vcbeat-m）', ewm: 'pic/contact/swxq.png' }
            ],
            entity_list: [
                {'path': 'pic/index/case/1.jpg'},
                {'path': 'pic/index/case/2.png'},
                {'path': 'pic/index/case/3.png'},
                {'path': 'pic/index/case/4.png'},
                {'path': 'pic/index/case/5.png'},
                {'path': 'pic/index/case/6.png'},
                {'path': 'pic/index/case/7.png'},
                {'path': 'pic/index/case/8.png'},
                {'path': 'pic/index/case/9.png'},
                {'path': 'pic/index/case/10.png'},
                {'path': 'pic/index/case/11.png'},
                {'path': 'pic/index/case/12.png'},
                {'path': 'pic/index/case/13.png'},
                {'path': 'pic/index/case/14.png'},
                {'path': 'pic/index/case/15.png'},
                {'path': 'pic/index/case/16.png'},
                {'path': 'pic/index/case/17.png'},
                {'path': 'pic/index/case/18.png'},
                {'path': 'pic/index/case/19.png'},
                {'path': 'pic/index/case/20.png'}
            ]
      }
  }
}
</script>
<style lang="stylus" scoped>
.about
    .bg
        height 400px
        display flex
        justify-content center
        overflow hidden
        position relative
        img
            display block
            height 400px
        div
            position absolute
            left 50%
            transform translateX(-50%)
            top 150px
            text-align center
        .p1
            font-size 40px
            font-weight 400
            line-height 56px
            color rgba(255, 255, 255, 1)
        .p2
            font-size 20px
            font-weight 400
            color rgba(255, 255, 255, 1)
            line-height 28px
            padding-left 2px
    .center
        width 1200px
        margin 0 auto
        position relative
        top: -40px
        .content
            padding 60px 90px 40px
            background-color #fff
            box-shadow 0px 4px 30px 0px rgba(109,93,79,0.1)
            .item
                padding: 0 100px
                position: relative
                text-align: center
                &.intro
                    padding: 20px 100px
                .title
                    position: relative
                    display: inline-block
                    font-size: 32px
                    color: #000000
                    line-height:45px
                    margin-bottom: 16px
                    img
                        width: 17px
                        position: absolute
                        bottom: 8px
                    &-l
                        img
                            left: -34px
                    &-r
                        img
                            right: -34px
                .desc
                    font-size: 16px
                    color: #333
                    line-height: 26px
                    text-align: left
                .introl,.intror
                    width: 24px
                    position: absolute
                .introl
                    left: 0
                    top: 0
                .intror
                    right: 0
                    bottom: 0
                .cooperation-list
                    text-align: center
                    font-size: 0
                    a
                        display: inline-block
                        width: 120px
                        height: 48px
                        border: 1px solid rgba(233,233,233,1)
                        vertical-align: middle
                        line-height: 46px
                        margin: 8px
                    div
                        display: inline-block
                        width: 120px
                        height: 48px
                        border: 1px solid rgba(233,233,233,1)
                        vertical-align: middle
                        line-height: 46px
                        margin: 8px
                    img
                        max-width: 100%
                        max-height: 100%
                        vertical-align: middle
                .list
                    display grid
                    grid-template-columns repeat(2, 1fr)
                    grid-gap 10px
                    text-align left
                    >div
                        background-color #F9F9F9
                        padding 16px 20px
                        display flex
                        justify-content space-between
                    .line
                        width 20px
                        height 1px
                        background rgba(250, 122, 80, 1)
                        margin 6px 0 10px
                    .p1
                        font-size 18px
                        color rgba(34, 34, 34, 1)
                        line-height 25px
                        margin-top 4px
                    .p2
                        font-size 14px
                        color rgba(85, 85, 85, 1)
                        line-height 20px
                    img
                        width 90px
                        height 90px
            .item+.item
                margin-top: 56px
                
</style>